import React from "react";
import arquitect_1 from "../../images/arquitect_1.jpeg";
import arquitect_2 from "../../images/arquitect_2.jpeg";
import arquitect_3 from "../../images/arquitect_3.jpeg";
import arquitect_4 from "../../images/arquitect_4.jpeg";
import arquitect_5 from "../../images/arquitect_5.jpeg";
import arquitect_6 from "../../images/arquitect_6.jpeg";
import arquitect_7 from "../../images/arquitect_7.jpeg";
import arquitect_8 from "../../images/arquitect_8.jpeg";
import arquitect_9 from "../../images/arquitect_10.jpeg";

import "./SpinningPictures.css";

export default function SpinningPictures() {

    const images = [arquitect_1, arquitect_2, arquitect_3, arquitect_4, arquitect_5, arquitect_6, arquitect_7, arquitect_8, arquitect_9];


    return (
        <div className="images3dContainer">
            <div className="spinningOuter">
                <div className="spinningInner">
                    {images.map(element => <figure className="spinningImgs" key={element.toString()}><img src={element} alt={element.toString()}/></figure>)}
                </div>
            </div>
                  
        </div>
    )
}